import React from 'react'
import { PlusOutlined, CreditCardOutlined, FileTextOutlined } from '@ant-design/icons';

import { Col, Typography, Form, Input, InputNumber, DatePicker, Button, Row, } from "antd"
import { useTranslation } from 'react-i18next';
const { Title } = Typography
function PaiementFormForModal({ form, handleFinish }) {
    const { t } = useTranslation();
    return (

        <Row gutter={[16, 16]}>
            <Col span={24}>
                <Title level={2} style={{ display: 'flex', alignItems: 'center' }}>{t("form.paiement.title.modif")}
                    <div style={{ marginLeft: "5px" }}>
                        <CreditCardOutlined style={{ fontSize: '24px', color: '#f88e8e', marginRight: 8 }} />
                        <PlusOutlined style={{ fontSize: '18px', color: '#f88e8e' }} />
                    </div>
                </Title>
            </Col>
            {/* Formulaire */}
            <Col span={24}>
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleFinish}
                    name="paiement_form_modif"
                    id="paiement_form_modif"
                >
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                label={t("form.paiements.label.employee")}
                                name="fullName"
                                rules={[{ required: true, message: t("form.paiements.input.employee.require") }]}
                            >
                                <Input disabled prefix={<FileTextOutlined style={{ color: "#f3db56" }} />} className="custom-input" />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col xs={24} sm={12}>
                            <Form.Item
                                label={t("form.paiements.label.tarif")}
                                name="amount"
                                rules={[{ required: true, message: t("form.paiements.input.tarif.require") }]}
                            >
                                <InputNumber style={{ width: "100%" }} prefix={<FileTextOutlined style={{ color: "#f3db56" }} />} className="custom-input" />
                            </Form.Item>
                        </Col>

                        <Col xs={24} sm={12}>
                            <Form.Item
                                label={t("form.paiements.label.date")}
                                name="paymentDate"
                                rules={[{ required: true, message: t("form.paiements.input.date.require") }]}
                            >
                                <DatePicker prefix={<FileTextOutlined style={{ color: "#f3db56", }} />} style={{ width: "100%" }} className="custom-input" />
                            </Form.Item>
                        </Col>
                    </Row>

                </Form>
            </Col>
        </Row>
    )
}

export default PaiementFormForModal